import { render, staticRenderFns } from "./Login.ForgotPwd.vue?vue&type=template&id=67a3e60a&scoped=true"
import script from "./Login.ForgotPwd.vue?vue&type=script&lang=js"
export * from "./Login.ForgotPwd.vue?vue&type=script&lang=js"
import style0 from "./Login.ForgotPwd.vue?vue&type=style&index=0&id=67a3e60a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a3e60a",
  null
  
)

export default component.exports